import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Box } from '@material-ui/core';
import { useHistory } from 'react-router-dom';

import { useStyles, customCardStyles } from './TaxRulesetHistory.styled';
import i18n from 'i18n-js';
import { Card } from 'components/UI';
import { Table } from 'components/UI';
import { PricingActions } from 'state/modules/pricing';
import { buildUrl } from 'utils';
import { DatetimeField } from 'components/DatetimeField';

export const TaxRulesetHistory = (props) => {
  const { excludeTaxRuleset, originId } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const cardClasses = customCardStyles();
  const [params, setParams] = useState({
    exclude_tax_ruleset: excludeTaxRuleset,
    origin_id: originId,
    archived: true,
    limit: 5,
    page: 1,
  });
  const list = useSelector((state) => state?.pricing?.taxRulesets.data);
  const pagination = useSelector((state) => state?.pricing?.taxRulesets.pagination);
  const loading = useSelector((state) => state?.pricing?.taxRulesets.fetchingTaxRulesets);
  const title = i18n.t('tax_ruleset.rulesets_history');

  /**
   * Table columns
   * Show or hide columns with omit key
   */
  const columns = [
    {
      name: i18n.t('common.id'),
      selector: 'id',
      grow: 0,
      minWidth: '4rem',
    },
    {
      name: i18n.t('tax_ruleset.rulesets'),
      selector: 'name',
      cell: (row) => row?.name,
      minWidth: '10rem',
    },
    {
      name: i18n.t('common.start_date'),
      selector: 'created_time',
      cell: (row) => <DatetimeField datetime={row?.created_time} />,
      grow: 1,
      minWidth: '10rem',
    },
    {
      name: i18n.t('common.end_date'),
      selector: 'archived',
      cell: (row) => <DatetimeField datetime={row?.archived} />,
      grow: 1,
      minWidth: '10rem',
    },
  ];

  const fetchTaxHistory = useCallback(
    (params) => {
      dispatch(PricingActions.fetchTaxRulesets(params));
    },
    [dispatch]
  );

  const handlePageChange = (page) => {
    const newParams = { page, limit: params.limit };
    setParams({ ...params, ...newParams });
  };

  const handleRowClick = (taxRuleset) => {
    history.push(buildUrl(`/tax-rulesets/${taxRuleset.id}`));
  };

  // Fetch tax ruleset history on params change
  useEffect(() => {
    if (params?.origin_id) {
      fetchTaxHistory(params);
    }
  }, [fetchTaxHistory, params]);

  useEffect(() => {
    if (originId && excludeTaxRuleset) {
      setParams((params) => ({
        ...params,
        origin_id: originId,
        exclude_tax_ruleset: excludeTaxRuleset,
      }));
    }
  }, [fetchTaxHistory, originId, excludeTaxRuleset]);

  return (
    <Card
      menuItems={[]}
      headerActionType="vertical"
      contentRootClasses={cardClasses}
      data-cy="taxruleset-history-widget"
      title={title}
    >
      <Box className={classes.cardContentPadding}>
        <Table
          data={list}
          columns={columns}
          loading={loading}
          handlePageChange={handlePageChange}
          paginationPerPage={params?.limit || 0}
          totalRows={pagination?.totalRows || 0}
          paginationComponentOptions={{ noRowsPerPage: true }}
          handleRowClicked={handleRowClick}
        />
      </Box>
    </Card>
  );
};
